// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactview {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.contactview-contact-container {
  display: flex;
  height: 100%;
  width: calc(100% - 395px);
}

.contactview-content-fill {
  width: 100%;
}

.contactview-conversation-list-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 395px;
  border-left: 1px solid rgb(200, 200, 200);
}

.contactview-conversation-list-header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 86px;
  padding: 16px 16px 8px 16px;
  background-color: rgb(220, 220, 220);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.contactview-conversation-list-header span {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  color: rgb(51, 51, 51);
  text-align: left;
}

.contactview-conversation-list-wrapper {
  height: calc(100% - 86px);
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Contacts/ContactView/ContactView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb","sourcesContent":[".contactview {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.contactview-contact-container {\n  display: flex;\n  height: 100%;\n  width: calc(100% - 395px);\n}\n\n.contactview-content-fill {\n  width: 100%;\n}\n\n.contactview-conversation-list-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 395px;\n  border-left: 1px solid rgb(200, 200, 200);\n}\n\n.contactview-conversation-list-header {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  height: 86px;\n  padding: 16px 16px 8px 16px;\n  background-color: rgb(220, 220, 220);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.contactview-conversation-list-header span {\n  font-family: Roboto, sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: bold;\n  color: rgb(51, 51, 51);\n  text-align: left;\n}\n\n.contactview-conversation-list-wrapper {\n  height: calc(100% - 86px);\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
